export default "__VITE_ASSET__$ds3gSyc__"